export const REQUIRED_ONBOARDING_DOCS = ['contractor', 'w9', 'directDeposit'];

export function isOnboardingComplete(onboarding = {}) {
  return REQUIRED_ONBOARDING_DOCS.every((kind) => onboarding?.[kind]?.status === 'signed');
}

/**
 * Onboarding no longer stands between a new agent and the app.
 *
 * It used to: a profile invited with onboarding.required was bounced to
 * /onboarding on every route until all three documents came back
 * signed. That made the first thing a new hire met a demand for their
 * SSN and bank account before they had seen a single screen — and the
 * work they were hired to do waited on paperwork that only accounting
 * needs, and only needs before the first commission is paid.
 *
 * The paperwork is still collected and still tracked; it is a reminder
 * now rather than a gate. What enforces it is the thing it actually
 * blocks — a payout cannot be made to an agent with no W-9 and no bank
 * account on file — not the login.
 *
 * Nothing calls this to decide access any more. It answers the banner's
 * question: is there paperwork this person still owes?
 */
export function userOnboardingPending(user) {
  if (!user) return false;
  if (user.role === 'admin' || user.role === 'buyer') return false;
  // Only people who were actually asked. Legacy profiles predate the
  // packet and are not nagged for it.
  if (user.onboarding?.required !== true) return false;
  return !isOnboardingComplete(user.onboarding || {});
}
